import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker so Chrome / Android can fire beforeinstallprompt
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}

// Capture beforeinstallprompt event globally so any component can trigger install
window.__hnDeferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__hnDeferredPrompt = e;
  window.dispatchEvent(new CustomEvent("hn-install-available"));
});
window.addEventListener("appinstalled", () => {
  window.__hnDeferredPrompt = null;
  window.dispatchEvent(new CustomEvent("hn-install-done"));
});
